import { render } from "./SubscriptionDetailsPage.vue?vue&type=template&id=40ca1ecd&scoped=true"
import script from "./SubscriptionDetailsPage.vue?vue&type=script&lang=js"
export * from "./SubscriptionDetailsPage.vue?vue&type=script&lang=js"

import "./SubscriptionDetailsPage.vue?vue&type=style&index=0&id=40ca1ecd&lang=scss&scoped=true"

import exportComponent from "/home/mon3m/mon3m/dafater/ManageSPA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40ca1ecd"]])

export default __exports__